import TaxCouponFinishPage from './TaxCouponFinishPage'

export default TaxCouponFinishPage
